<script setup>
    import NoticeComponent from "../../layouts/components/Notice.vue";
    import HeadlineComponent from "../../form/components/Headline.vue";
    import utilHelper from "../../app/utilHelper";
    const {getPjLogoImagePath} = utilHelper();
    import {defineProps, inject} from 'vue';
    const SHIRONEKO_PROJECT = inject('SHIRONEKO_PROJECT');
    const MAGICIANWIZ = inject('MAGICIANWIZ');
    const props = defineProps({
        code: String,
    });
    const title = 'アカウント復旧のお問い合わせについて';
    function getProjectName () {
        switch (props.code) {
            case SHIRONEKO_PROJECT:
                return '白猫プロジェクト';
            case MAGICIANWIZ:
                return 'クイズRPG 魔法使いと黒猫のウィズ';
        }
    }
    function getMessage () {
        return getProjectName() + 'のゲームアカウントの復旧についてお問い合わせいただくフォームです。\n' +
            'フォームに沿って、復旧希望のゲームアカウント情報をご入力ください。\n' +
            '※所要時間5〜10分ほど';
    }


</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component :title="title"></headline-component>
            <div id="guidance-wrapper" class="uk-margin uk-flex-1">
                <div>
                    <NoticeComponent class="uk-width-1-1" :message="getMessage()"/>
                </div>
                <div id="image-wrapper" class="uk-position-relative uk-flex uk-flex-center">
                    <img :src="getPjLogoImagePath(code)" alt="logo" class="uk-margin uk-position-absolute uk-width-1 uk-height-1-1"/>
                </div>
            </div>
            <div class="uk-margin uk-text-center">
                <router-link to="/agreement">
                    <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto">進む</button>
                </router-link>
            </div>

        </div>
    </div>
</template>

<style scoped>
    #guidance-wrapper {
        display: grid;
        grid-template-rows: auto 1fr;
    }
    #image-wrapper {
        img {
            max-width: 300px;
            object-fit: contain;
        }
    }
</style>